import _ from 'lodash';
import icons from '@/util/icons';
import InterestIcon from '@/components/interest-icon/InterestIcon.vue';
import 'vue-awesome/icons/angle-left';
import 'vue-awesome/icons/angle-right';

export default {
  dependencies: [
    'genericConfigService',
  ],
  props: {
    interests: Array,
    selected: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'interest-icon': InterestIcon,
  },
  data() {
    return {
      clickedOk: false,
      internalSelected: [],
      icons,
      interestsMax: 1,
      notNextTick: false,
      interestSwiperOption: {
        autoplay: 0,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        debugger: true,
        observeParents: true,
      },
      chunkedInterests: [],
    };
  },
  mounted() {
    this.$root.$on('hidden::modal', () => {
      if (!this.clickedOk) {
        this.cancel();
      }
      this.clickedOk = false; // Reset click
    });

    this.internalSelected = this.selected;

    return Promise.all([
      this.genericConfigService.getConfig()
        .then(c => this.interestsMax = c.interests_maximum),
    ]);
  },
  computed: {
    selectedInterests() {
      if (Array.isArray(this.interests) && this.selected.length) {
        return this.interests.filter(i => this.selected.indexOf(i.id) >= 0);
      }
      return false;
    },
  },
  methods: {
    selectInterest(id) {
      // If we have one interest we can change interests just by clicking on other
      // (no need to click again on active interest to remove it)
      if (this.interestsMax === 1) {
        this.internalSelected = [id];
        return;
      }

      const sel = _.cloneDeep(this.internalSelected);
      const idx = this.internalSelected.indexOf(id);
      if (idx === -1) {
        if (this.internalSelected.length === this.interestsMax && this.interestsMax > 0) {
          this.$toast.warn({ message: this.$t('error.maximum-interests', { count: this.interestsMax }) });
          return;
        }
        sel.push(id);
      } else {
        sel.splice(idx, 1);
      }
      this.internalSelected = sel;
    },
    confirm() {
      this.clickedOk = true;
      this.updateInterests();
    },
    cancel() {
      this.internalSelected = [];
      this.updateInterests();
    },
    showModal() {
      this.chunkedInterests = _.chunk(this.interests, 12);
      if (!this.disabled) {
        this.$refs.interestsModal.show();
      }
    },
    updateInterests() {
      this.$emit(
        'update:selected',
        this.internalSelected,
      );
      if (this.$refs.interestsModal) {
        this.$refs.interestsModal.hide();
      }
    },
    getInterestName(interest) {
      const key = `terms.interests.${interest.slug}.name`;
      if (key === this.$t(key)) {
        return interest.name;
      }
      return this.$t(key);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/interest-selector/InterestSelector.js